import { createContext } from 'react';
import type { ExtractedAnswersAPI } from '@trinity/chat';

export type GetExtractedAnswersAPI = (
  data: ExtractedAnswersAPI.GetExtractedAnswers.Request
) => Promise<ExtractedAnswersAPI.GetExtractedAnswers.Response>;

export type ExtractedAnswersAPIContextValue = {
  getExtractedAnswers: GetExtractedAnswersAPI;
};

export const ExtractedAnswersAPIContext = createContext<ExtractedAnswersAPIContextValue | null>(null);

ExtractedAnswersAPIContext.displayName = 'ExtractedAnswersAPIContext';
